// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202511061405/js/" + chunkId + "." + {"44":"2046e596","225":"b2d7dc82","481":"2dc7592d","486":"ccac95bf","770":"af18a39e"}[chunkId] + ".0.42221886198035863.chunk.js";
};